<div
  *ngIf="showOnlinePaymentOutageBanner && !isOutageBannerClosed"
  class="flex items-center gap-2 p-2 bg-vtmn-play-status-warning text-white"
  role="alert"
>
  <p class="flex-grow m-0 text-center">
    {{ 'attendee.online_payment_outage_banner.message' | translate }}
  </p>
  <button
    type="button"
    class="flex-shrink-0 text-white"
    [attr.aria-label]="
      'organizer.online_payment_outage_banner.close' | translate
    "
    (click)="closeOutageBanner()"
  >
    <vtmn-play-icon [name]="closeIconType"></vtmn-play-icon>
  </button>
</div>

<app-header
  [user]="user"
  [homeLink]="homeLink"
  (login)="login()"
  [dropdownMenuItems]="headerDropdownMenuItems"
  class="block bg-white"
>
  <app-attendee-header-navigation
    *ngIf="links?.length"
    navigation
    [links]="links"
    class="col-span-12 order-2 mt-2 -mb-2 -mx-3 xs:-mx-6 sm:-mx-9 lg:mb-0 lg:col-span-4 lg:order-none lg:h-full lg:m-0"
  ></app-attendee-header-navigation>

  <app-navigation-tab-bar
    *ngIf="tabBarButtonsConfig && tabBarButtonsConfig?.length > 0"
    tab-navigation
    [buttonsConfig]="tabBarButtonsConfig"
    class="hidden fixed z-1 bottom-0 left-0 w-full lg:flex lg:static"
  ></app-navigation-tab-bar>
</app-header>
